/** @format */

import React, { useState } from 'react';
import { isWebpSupported } from 'react-image-webp/dist/utils';
import { useDispatch } from 'react-redux';
import { openVideo } from '../../features/video';
import '../../css/cards/Result.css';

import {
  FacebookShareButton,
  FacebookIcon,
  TwitterShareButton,
  TwitterIcon,
  WhatsappShareButton,
  WhatsappIcon,
  TelegramShareButton,
  TelegramIcon,
} from 'react-share';

import { IoPlay, IoShareSocialSharp } from 'react-icons/io5';

import libel from '../../images/logo_dot.png';

const Result = ({ result }) => {
  const dispatch = useDispatch();
  const [showShare, setShowShare] = useState(false);

  const shareUrl = 'https://libel.academy';
  const SocialIconStyle = { margin: '0px 2px', borderRadius: 5 };
  const shareQuote = 'Conviértete en profesional 3D';
  
  const technologyColor = (technology) => {
    switch (technology) {
      case 'Blender':
        return { backgroundColor: '#e87c0d' };
      case 'ZBrush':
        return { backgroundColor: '#5142fc' };
      case 'Substance':
        return { backgroundColor: '#7aba2e' };
      default:
        return { backgroundColor: '#6000de' };
    }
  };

  return (
    <div className="Result">
      <div
        className="result-image"
        style={
          isWebpSupported()
            ? { backgroundImage: `url(${result.imageWebp})` }
            : { backgroundImage: `url(${result.image})` }
        }
      >
        <button
          className="result-video-button"
          onClick={() => {
            dispatch(
              openVideo({
                modal: true,
                url: result.video,
                type: 'common',
              })
            );
          }}
        >
          <IoPlay className="result-video-icon" />
          <span>Ver Video</span>
        </button>
        <div
          className="results-share-button"
          onClick={() => {
            setShowShare(!showShare);
          }}
        >
          <IoShareSocialSharp />
          <div
            className="result-social-networks-box"
            style={
              showShare
                ? { visibility: 'visible', opacity: 1 }
                : { visibility: 'hidden', opacity: 0 }
            }
          >
            <FacebookShareButton url={shareUrl} quote={shareQuote}>
              <FacebookIcon size={20} style={SocialIconStyle} />
            </FacebookShareButton>
            <TwitterShareButton url={shareUrl} quote={shareQuote}>
              <TwitterIcon size={20} style={SocialIconStyle} />
            </TwitterShareButton>
            <WhatsappShareButton url={shareUrl} quote={shareQuote}>
              <WhatsappIcon size={20} style={SocialIconStyle} />
            </WhatsappShareButton>
            <TelegramShareButton url={shareUrl} quote={shareQuote}>
              <TelegramIcon size={20} style={SocialIconStyle} />
            </TelegramShareButton>
          </div>
        </div>
      </div>
      <div className="result-header">
        <h1>{result.project}</h1>
        <span
          style={
            technologyColor(result.technology)
          }
        >
          {result.technology}
        </span>
      </div>
      <div className="result-information">
        <div className="result-user">
          <div className="result-user-avatar">
            <img src={libel} alt="Libel Academy" />
          </div>
          <div className="result-user-name">
            <h2>{result.student}</h2>
            <h3>{result.country}</h3>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Result;
